<template>
  <div>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <div v-if="successfully_feedback === false">
      <div id="url_expired" style="text-align: center; width: 90%;">
        <h4>Welcome to Doodhvale, Please wait...</h4>
      </div>
      <div id="url_valid">
        <div style="text-align: center;">
          <div><h4>Welcome {{userDetails.first_name}}<br>({{userDetails.mobile}})</h4></div>
          <div style="padding: 5%;">
          {{userDetails.address}}</div>
          *****
          <div style="padding: 5%;">{{text1}}</div><br>
          <img v-bind:src="imageContent" style="width: 90%;"/><br><br>
          <div style="padding: 5%;">{{text2}}</div>
          <input class="buttonOnDelFbLoc" value="UPDATE LOCATION" type="button" v-on:click="locationModule();">
          <!-- <img src="../../../../static/img/sad.png" style="width:15%;"><br> -->
          <!-- <div style="width: 90%"><b>Sorry! Inconvenience deeply regretted.</b><br> If you disagree with our delivery partner's statement then please press below<br> “<b>I DISAGREE</b>” button.</div> -->
          <!-- <button class="disagree" v-on:click="disagree();">I DISAGREE</button> -->
        </div>
      </div>
    </div>
    <div v-if="successfully_feedback">
      <div style="text-align: center; width: 90%;">
        <br><br>
        <img src="../../../../static/img/like.png" style="width:15%;"><br><br>
        Thanks {{userDetails.first_name}} <br>
        Your feedback is sent to our delivery partner. It will not repeat again!!<br><br>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import LTable from 'src/components/UIComponents/Table.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  import axios from 'axios'
  export default {
    components: {
      Checkbox,
      Card,
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        urlInterface: [],
        apiDataObj: [],
        userDetails: [],
        disagreeResponse: [],
        successfully_feedback: false,
        isLoading: true,
        isFullPage: true,
        text1: '',
        text2: '',
        imageFormat: '',
        imageContent: ''
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        const params = new URLSearchParams()
        var fullUrl = document.URL
        var splitUrl = fullUrl.split('f1?')
        params.append('url_str', splitUrl[1])
        axios({
          url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.urlInterface = {}
          if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
            this.urlInterface.error_msg = response.data.msg
            document.getElementById('url_valid').style.display = 'none'
            this.isLoading = false
          } else {
            document.getElementById('url_expired').style.display = 'none'
            this.urlInterface.action_name = response.data.action_name
            this.urlInterface.url_interface_id = response.data.url_interface_id
            this.invokeUrlAction()
            this.isLoading = false
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      invokeUrlAction () {
        const params = new URLSearchParams()
        params.append('url_interface_id', this.urlInterface.url_interface_id)
        params.append('action_name', this.urlInterface.action_name)
        axios({
          url: process.env.BASE_API + '/accounts/invoke-url-action',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.apiDataObj = {}
          switch (this.urlInterface.action_name) {
            case 'all_not_taken_cust_loc_set_db_in_range':
            case 'not_open_cust_loc_set_db_in_range':
              this.apiDataObj.userId = response.data.action_response.user_id
              this.apiDataObj.deliveryDate = response.data.action_response.delivery_date
              this.apiDataObj.deliveryId = response.data.action_response.delivery_id
              this.text1 = response.data.action_response.text1
              this.text2 = response.data.action_response.text2
              this.imageFormat = response.data.action_response.image_format
              this.imageContent = response.data.action_response.image_content
              this.userInfo()
              this.isLoading = false
              break
            default:
              break
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      userInfo () {
        const params = new URLSearchParams()
        var userId = this.apiDataObj.userId
        params.append('user_id', userId)
        axios({
          url: process.env.BASE_API + '/users/user-info',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.userDetails = {}
          this.userDetails.userId = userId
          this.userDetails.first_name = response.data.user_record.user_details.first_name
          this.userDetails.mobile = response.data.user_record.user.username
          this.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      locationModule () {
        // alert('location')
        sessionStorage.setItem('userId', this.userDetails.userId)
        sessionStorage.setItem('isProfile', 1)
        sessionStorage.setItem('actionName', 'subscription')
        sessionStorage.setItem('callbackUrlForSubscription', document.URL)
        sessionStorage.setItem('locationAction', 'getOldLocation')
        this.$router.push('/a/location')
      }
    }
  }
</script>
<style>
.buttonOnDelFbLoc {
  background-color: #3CB6C3;
  padding: 2% 17% 2% 18%;
  width: 90%;
  color: white;
  border: none;
}
.loading-icon:before {content: "Wait...";}
.loading-overlay .loading-icon:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #3CB6C3;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  height: 1em;
  position: relative;
  width: 1em;
  position: absolute;
  top: calc(50% - 1.5em);
  left: calc(50% - 1.5em);
  width: 3em;
  height: 3em;
  border-width: 0.25em;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Delfbloc.vue